import {
  DefenseEventTypes,
  IDefenseEventNotifyAddUpdateVisitorProps,
} from '../../../../services/Defense/Events/types';
import { Box, Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React, { useEffect, useState } from 'react';
import CarrouselImagesComponent from '../../../../components/CarrouselImagesComponent/CarrouselImagesComponent';
import { convertEventType } from '../../../../converters/Defense/ConverterDefense';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyAddUpdateVisitorContentProps {
  event: IDefenseEventNotifyAddUpdateVisitorProps;
}

const DefenseNotifyAddUpdateVisitorContent = ({
  event,
}: IDefenseNotifyAddUpdateVisitorContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  const formatDefenseDate = (date: Date) => {
    return dayjs(date);
  };
  const [images, setImages] = useState<string[]>([]);
  const [urls, setUrls] = useState<string[]>([]);

  useEffect(() => {
    if (images && images.length > 0) {
      const imageUrls = images.map((i) => `data:image/jpg;base64, ${i}`);
      setUrls(imageUrls);
    }
  }, [images]);

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="ID Visitante"
          value={event?.visitorId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Nome do Visitante"
          value={event?.visitorName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Origem do Visitante"
          value={event?.visitorSource ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Organização do Visitante"
          value={event?.visitorOrganization ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Organização Visitada"
          value={event?.visitedOrganization ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Celular do Visitante"
          value={event?.visitorPhone ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="E-mail do Visitante"
          value={event?.visitorEmail ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <DateFieldComponent
          label="Data/Hora de Chegada do Visitante"
          value={formatDefenseDate(event?.visitorArrivalTime)}
          readOnly={true}
        />
        <DateFieldComponent
          label="Data/Hora de Saída do Visitante"
          value={formatDefenseDate(event?.visitorLeaveTime)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Organização Visitada"
          value={event?.visitedOrganization ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Organização Visitada"
          value={event?.visitedOrganization ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Organização Visitada"
          value={event?.visitedOrganization ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Razão da visita"
          value={event.visitReason ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
        <TextFieldComponent
          label="ID Pessoa"
          value={event?.personId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Placa de Carro"
          value={event?.personId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      {event.authInfo != null && (
        <Grid2
          flexDirection={'row'}
          justifyContent={'center'}
          alignItems={'center'}
          size={12}
        >
          <TextFieldComponent
            label="id"
            value={event?.authInfo.id ?? 'Não Possui'}
            type={'text'}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <TextFieldComponent
            label="ID Pessoa"
            value={event?.authInfo.sipId ?? 'Não Possui'}
            type={'text'}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
          />
          <Box
            sx={{
              width: 'auto',
              height: 'auto',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CarrouselImagesComponent items={urls} />
          </Box>
        </Grid2>
      )}
    </Grid2>
  );
};

export default DefenseNotifyAddUpdateVisitorContent;
